import { useContext } from 'react';
import { QueryContext, useDataModel } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { getLoyaltyMembershipInput } from '../utils/product-utils';

export const useDataProducts = ({ itemIds, itemQuantities, skip = false }) => {
  const { defaultVariables } = useContext(QueryContext);
  const { membershipInformation } = useStore();
  const loyaltyMembershipInput = getLoyaltyMembershipInput(membershipInformation);

  const { data, loading, error } = useDataModel('products', {
    variables: {
      itemIds,
      ...(itemQuantities?.length && { itemQuantities }),
      loyaltyMembershipInput,
      ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
        isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
      })
    },
    skip: !itemIds || skip,
    fetchPolicy: 'cache-first'
  });

  return {
    data,
    loading,
    error
  };
};